import { createSlice } from "@reduxjs/toolkit";
const VAT_RATE = 0.05;
const cartSlice = createSlice({
  name: "cart",
  initialState: {
    items: [],
    totalQuantity: 0,
    totalPrice: 0,
    totalVAT: 0,
    totalPriceWithoutVat: 0,
  },
  reducers: {
    addToCart: (state: any, action: any) => {
      const item = state.items.find((i: any) => i.id === action.payload.id);
      if (item) {
        state.totalQuantity += action.payload.quantity - item.quantity;

        state.totalPrice +=
          action.payload.quantity * action.payload.price -
          item.quantity * item.price;

        state.totalPriceWithoutVat +=
          (action.payload.quantity * action.payload.price -
            item.quantity * item.price) /
          (1 + VAT_RATE);

        state.totalVAT +=
          action.payload.quantity * action.payload.vat -
          item.quantity * item.vat;

        if (action.payload.quantity === 0) {
          state.items = state.items.filter(
            (i: any) => i.id !== action.payload.id
          );
        } else {
          item.quantity = action.payload.quantity;
        }
      } else if (action.payload.quantity > 0) {
        // Add a new item to the cart
        state.items.push({ ...action.payload });
        state.totalQuantity += action.payload.quantity;
        state.totalPrice += action.payload.quantity * action.payload.price;
        state.totalVAT += action.payload.quantity * action.payload.vat;
        state.totalPriceWithoutVat +=
          (action.payload.quantity * action.payload.price) / (1 + VAT_RATE);
      }
    },

    removeFromCart: (state: any, action: any) => {
      const item = state.items.find((i: any) => i.id === action.payload.id);
      if (item) {
        // Subtract the item's quantity and price from totalQuantity and totalPrice
        state.totalQuantity -= item.quantity;
        state.totalPrice -= item.quantity * item.price;
      }
      state.items = state.items.filter(
        (item: any) => item.id !== action.payload.id
      );
    },

    updateQuantity: (state: any, action: any) => {
      const item = state.items.find((i: any) => i.id === action.payload.id);
      if (item) {
        // Update totalQuantity and totalPrice based on the change in quantity
        state.totalQuantity += action.payload.quantity - item.quantity;
        state.totalPrice +=
          action.payload.quantity * item.price - item.quantity * item.price;

        if (action.payload.quantity === 0) {
          state.items = state.items.filter(
            (i: any) => i.id !== action.payload.id
          );
        } else {
          item.quantity = action.payload.quantity;
        }
      }
    },
   updateItemPrice: (state: any, action: any) => {
    const itemIndex = state.items.findIndex((i: any) => i.id === action.payload.id);
    
    if (itemIndex !== -1) {
        const item = state.items[itemIndex];
        const oldPrice = item.price; 
        const newPrice = action.payload.price;
        item.price = newPrice;
        state.totalPrice += (newPrice * item.quantity) - (oldPrice * item.quantity);
        state.totalPriceWithoutVat += ((newPrice * item.quantity) - (oldPrice * item.quantity)) / (1 + VAT_RATE);
       
    }
},
    clearCart: (state) => {
      // Reset totalQuantity and totalPrice to 0 when the cart is cleared
      state.items = [];
      state.totalQuantity = 0;
      state.totalPrice = 0;
      state.totalVAT = 0;
      state.totalPriceWithoutVat = 0;
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart,updateItemPrice } =
  cartSlice.actions;

export default cartSlice.reducer;
